<template>
    <div id="create-folder" v-mdl class="mdl-card mdl-shadow--6dp">
        <div class="mdl-card__title">
            <h2 class="mdl-card__title-text">
                {{ $t('folders.create') }}
            </h2>
        </div>

        <div class="mdl-card__supporting-text">
            <div class="mdl-textfield mdl-js-textfield">
                <input id="folder-name" v-model="name" class="mdl-textfield__input" maxlength="100" autofocus @keyup.enter="create">
                <label class="mdl-textfield__label" for="folder-name">{{ $t('folders.name') }}</label>
            </div>
        </div>

        <div class="mdl-card__actions mdl-card--border">
            <button id="create" class="mdl-button mdl-js-button mdl-js-ripple-effect" :disabled="loading" @click="create">
                {{ $t('dialog.create') }}
            </button>
            <button id="cancel" class="mdl-button mdl-js-button mdl-js-ripple-effect" @click="goToFolders">
                {{ $t('dialog.cancel') }}
            </button>
        </div>

        <transition name="loading-fade">
            <div v-if="loading" class="loading-center">
                <spinner />
            </div>
        </transition>
    </div>
</template>

<script>
import { Api, Util } from '@/utils/';
import Spinner from '@/components/Spinner.vue';

// PULS-1424: Android's create folder dialog (FolderUtils.promptCreateNewFolder) asks only for a name.
// Folders.vue checks premium before routing here.
export default {
    name: 'CreateFolder',
    components: {
        Spinner
    },
    data () {
        return {
            name: "",
            loading: false,
        };
    },
    mounted () {
        this.$store.commit("loading", false);
        this.$store.commit('title', this.$t('folders.create'));
    },
    methods: {
        goToFolders () {
            this.$router.push({ name: "folders" });
        },
        create () {
            const name = this.name.trim();
            if (!name) {
                Util.snackbar(this.$t('folders.name_required'));
                return;
            }

            this.loading = true;
            Api.folders.create(name)
                .then(() => {
                    Util.snackbar(this.$t('folders.created', { name }));
                    this.goToFolders();
                })
                .catch(() => {
                    Util.snackbar(this.$t('folders.create_failed'));
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
    #create-folder {
        position: relative;
        width: 330px;
        height: 100%;
        margin: 5em auto;
    }

    .loading-center {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        margin: 57px auto 0;
        background: #fff;
        height: calc(100% - 57px);
        width: 100%;
    }
</style>
